function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { getProductTypeLabel } from '@finect/front-resources/Products';
import { Tabs, TabsPane } from '../../../Tabs';
import { Section } from '../../../Section';
import { GenericTable } from '../../../GenericTable';
import { getRows, getPlansRows } from '../utils';
import { geosEEUUArray, geosEuropeArray, geosAsiaArray, tematicasArray, realEstateArray } from '../data';
var DEFAULT_RENT_TOOLTIP = {
  title: 'Rentabilidad anualizada',
  text: 'Beneficio (o pérdida) que ha generado en este periodo de tiempo. Se expresa en porcentuaje anualizado.'
};
var CategoriesTabs = function (_React$Component) {
  _inherits(CategoriesTabs, _React$Component);
  var _super = _createSuper(CategoriesTabs);
  function CategoriesTabs() {
    var _this;
    _classCallCheck(this, CategoriesTabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      order: {
        type: 'none',
        field: null,
        ordering: 'child'
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOrderChange", function (order) {
      _this.setState({
        order: order
      });
    });
    return _this;
  }
  _createClass(CategoriesTabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        productType = _this$props.productType,
        commonProps = _this$props.commonProps,
        macrocategories = _this$props.macrocategories,
        categories = _this$props.categories;
      var commonPath = commonProps.commonPath,
        categoryPath = commonProps.categoryPath;
      var literal = getProductTypeLabel(productType, 'shortPlural', 'none');
      var currentYear = new Date().getFullYear();
      var columns = [{
        params: {
          textAlign: 'left'
        },
        component: 'Categoría',
        orderable: true,
        uniqueId: 'name'
      }, {
        params: {
          textAlign: 'right'
        },
        component: "".concat(literal),
        orderable: true,
        uniqueId: 'funds'
      }, {
        params: {
          textAlign: 'right'
        },
        component: 'Semana',
        orderable: true,
        uniqueId: 'Semana'
      }, {
        params: {
          textAlign: 'right'
        },
        component: 'Mes',
        orderable: true,
        uniqueId: 'Mes'
      }, {
        params: {
          textAlign: 'right'
        },
        component: "".concat(currentYear),
        orderable: true,
        uniqueId: "".concat(currentYear)
      }, {
        params: {
          textAlign: 'right'
        },
        component: '12 Meses',
        orderable: true,
        uniqueId: 'M12'
      }, {
        params: {
          textAlign: 'right'
        },
        component: '3 Años',
        orderable: true,
        uniqueId: 'M36',
        tooltip: DEFAULT_RENT_TOOLTIP
      }, {
        params: {
          textAlign: 'right'
        },
        component: '5 Años',
        orderable: true,
        uniqueId: 'M50',
        tooltip: DEFAULT_RENT_TOOLTIP
      }, {
        params: {
          textAlign: 'right'
        },
        component: '10 Años',
        orderable: true,
        uniqueId: 'M120',
        tooltip: DEFAULT_RENT_TOOLTIP
      }];
      if (['plan'].includes(productType.id)) {
        var rows = getPlansRows(productType, commonPath, categories, 'Planes de pensiones\r', [].concat(_toConsumableArray(tematicasArray), _toConsumableArray(geosAsiaArray), _toConsumableArray(geosEEUUArray), _toConsumableArray(geosEuropeArray), _toConsumableArray(realEstateArray)), true);
        return React.createElement(Section, {
          subtitle: "Rentabilidades en euros"
        }, React.createElement(GenericTable, {
          size: "small",
          rows: rows,
          columns: columns,
          order: this.state.order,
          onOrderChange: this.handleOrderChange
        }));
      }
      var tabs = macrocategories.map(function (tab) {
        return _objectSpread(_objectSpread({}, tab), {}, {
          rows: getRows(productType, commonPath, categories, tab.broad, tab.categories || [], tab.broad ? true : !tab.categories)
        });
      });
      var showingTabs = tabs.filter(function (item) {
        return item.rows.length;
      });
      var tabIndex = showingTabs.findIndex(function (tab) {
        return tab.name === categoryPath;
      });
      return React.createElement(Section, {
        title_: "Categor\xEDas",
        subtitle_: "Rentabilidades en euros"
      }, React.createElement(Tabs, {
        initial: tabIndex !== -1 ? tabIndex : 0
      }, showingTabs.map(function (tab, key) {
        return React.createElement(TabsPane, {
          key: key,
          to: "/".concat(commonPath, "/categoria/").concat(tab.name),
          title: tab.title
        }, React.createElement(GenericTable, {
          size: "small",
          rows: tab.rows,
          columns: columns,
          order: _this2.state.order,
          onOrderChange: _this2.handleOrderChange
        }));
      })));
    }
  }]);
  return CategoriesTabs;
}(React.Component);
export default CategoriesTabs;